export const deneigementTranslations = {
  // Barre urgence
  urgence_text: "Accumulation dangereuse ? Intervention 24h",

  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Déneigement de toit',
  hero_h1: 'Déneigement et déglaçage de toit à Lévis',
  hero_subtitle: "Accumulation de neige, barrage de glace, glaçons dangereux. Intervention rapide tout l'hiver, 7j/7.",
  hero_cta_call: 'Appeler maintenant',
  hero_cta_quote: 'Demander une soumission',
  hero_stat_1: 'Intervention 24h',
  hero_stat_2: "Service tout l'hiver",
  hero_stat_3: 'Équipe assurée CNESST',

  // Pourquoi déneiger
  pourquoi_h2: "Pourquoi le déneigement de toit n'attend pas à Lévis",
  pourquoi_1_title: 'STRUCTURE',
  pourquoi_1_desc: "Une accumulation de plus de 60 cm peut dépasser la capacité portante du toit. Risque d'affaissement réel.",
  pourquoi_2_title: 'INFILTRATIONS',
  pourquoi_2_desc: "Le barrage de glace force l'eau sous les bardeaux. Résultat : dégâts plafond, isolation détruite, moisissure.",
  pourquoi_3_title: 'SÉCURITÉ',
  pourquoi_3_desc: "Les glaçons et chutes de neige tuent ou blessent chaque hiver au Québec. Responsabilité légale du propriétaire.",

  // Services hiver
  services_h2: "Nos interventions hivernales à Lévis",
  service_1_title: 'DÉNEIGEMENT TOIT PLAT',
  service_1_desc: 'Pelletage manuel et soufflage, technique anti-déchirure de la membrane. Forfait par visite ou contrat saisonnier.',
  service_1_img: 'https://readdy.ai/api/search-image?query=Professional roofing crew removing heavy snow accumulation from flat commercial roof in Quebec winter, snow removal equipment, overcast snowy day, professional winter intervention photography, no text visible, documentary style, landscape composition',
  service_2_title: 'DÉNEIGEMENT TOIT EN PENTE',
  service_2_desc: 'Approche sécurisée avec harnais et corde de vie. Zones à risque ciblées (vallées, solins).',
  service_2_img: 'https://readdy.ai/api/search-image?query=Roofer with safety harness and lifeline clearing snow from sloped residential roof in Quebec winter, ice dam visible on edge, heavy snow accumulation, professional safety equipment, winter emergency photography, no text visible, landscape composition',
  service_3_title: 'DÉGLAÇAGE À LA VAPEUR',
  service_3_desc: "La méthode pro pour éliminer un barrage de glace sans abîmer le bardeau. Pas de sel, pas de hache.",
  service_3_img: 'https://readdy.ai/api/search-image?query=Professional steam ice dam removal from residential roof in Quebec winter, steam equipment melting ice dam, visible steam vapor, close-up professional winter intervention, blue and white tones, no text visible, editorial quality',
  service_4_title: 'RETRAIT DE GLAÇONS DANGEREUX',
  service_4_desc: "Intervention rapide quand des glaçons menacent passants, entrées ou voitures.",
  service_4_img: 'https://readdy.ai/api/search-image?query=Dangerous ice icicles hanging from residential roof edge, heavy snow and ice buildup, Quebec winter hazard, icicles threatening pedestrians below, professional emergency photography, overcast winter day, no text visible, landscape composition',

  // Prix
  prix_h2: "Prix du déneigement de toit à Lévis 2026",
  prix_table_type: 'Service',
  prix_table_price: 'Prix indicatif',
  prix_row1_type: 'Toit plat petit (garage, annexe)',
  prix_row1_price: '250 $ – 400 $',
  prix_row2_type: 'Toit plat moyen (duplex, maison)',
  prix_row2_price: '400 $ – 750 $',
  prix_row3_type: 'Toit en pente bungalow',
  prix_row3_price: '350 $ – 600 $',
  prix_row4_type: 'Toit en pente cottage/2 étages',
  prix_row4_price: '500 $ – 900 $',
  prix_row5_type: 'Déglaçage vapeur barrage de glace',
  prix_row5_price: '600 $ – 1 500 $',
  prix_row6_type: 'Contrat saisonnier (3-4 visites)',
  prix_row6_price: '-15% rabais',
  prix_note: "Prix selon accumulation, accès et durée. Soumission précise après évaluation visuelle.",

  // Urgence
  urgence_h2: "Quand appeler en urgence ?",
  urgence_1: "Accumulation de plus de 60 cm sur toit plat",
  urgence_2: 'Bruits de craquement dans la structure',
  urgence_3: "Eau qui coule à l'intérieur en plein hiver",
  urgence_4: "Glaçons de plus de 30 cm au bord du toit",
  urgence_5: 'Bombement visible du plafond intérieur',
  urgence_cta: "Disponible 7j/7",

  // Témoignage
  temoignage_quote: "Après la tempête dernière, on avait un barrage de glace monstrueux au-dessus de la cuisine. L'eau coulait le long du plafond à 7h du matin. J'ai appelé et l'équipe était là à 9h avec leur machine à vapeur. Trois heures plus tard, le problème était réglé — pas une seule trace, zéro dégâts supplémentaires. Un service vraiment pro en urgence.",
  temoignage_author: 'Sylvain G.',
  temoignage_city: 'Lévis centre',
  temoignage_detail: "Déglaçage urgence, février 2025",

  // FAQ
  faq_h2: "Questions fréquentes sur le déneigement",
  faq_q1: "À partir de combien de neige faut-il déneiger ?",
  faq_a1: "Pour les toits plats, on recommande le déneigement à partir de 45-60 cm d'accumulation. Pour les toits en pente, 30-45 cm peut déjà créer un barrage de glace dangereux. Après une tempête de verglas ou de neige lourde, mieux vaut appeler rapidement. Ne jouez pas avec la limite — un toit affaissé ou une infiltration coûte beaucoup plus cher qu'un déneigement préventif.",
  faq_q2: "Pourquoi pas utiliser du sel ou une hache moi-même ?",
  faq_a2: "Le sel abîme le bardeau, la membrane, les gouttières et l'environnement. Une hache risque de briser des bardeaux, d'abîmer la membrane d'étanchéité sous-jacente, ou de vous blesser gravement sur une échelle glissante. Le déglaçage à la vapeur est la seule méthode professionnelle qui élimine le glace sans endommager votre toiture. Laissez ça à une équipe assurée et équipée.",
  faq_q3: "Quelle différence entre déneigement et déglaçage ?",
  faq_a3: "Le déneigement retire la neige accumulée sur le toit pour alléger la charge et prévenir l'effondrement. Le déglaçage élimine le glace et le barrage de glace déjà formé, souvent avec de la vapeur chaude. Les deux peuvent être nécessaires : on déneige d'abord, puis on déglaçage si un barrage est présent. On évalue tout ça sur place et on vous donne un plan clair avant de commencer.",
  faq_q4: "Travaillez-vous les fins de semaine et soirs ?",
  faq_a4: "Oui, on intervient 7 jours sur 7 pendant la saison hivernale. Les urgences ne respectent pas les horaires de bureau. Quand un barrage de glace fait couler de l'eau dans votre salon à 21h un samedi soir, on comprend que ça ne peut pas attendre lundi. Appelez-nous — si la situation est urgente, on vient.",
  faq_q5: "Le déneigement est-il couvert par mon assurance habitation ?",
  faq_a5: "Ça dépend de votre police d'assurance. Certaines assureurs couvrent le déneigement si c'est prescrit après un sinistre (infiltration, affaissement). D'autres offrent une couverture préventive. On fournit un rapport d'intervention détaillé avec photos que vous pouvez soumettre à votre assureur. On vous conseille aussi de vérifier avec votre courtier avant la saison hivernale.",

  // CTA Final
  cta_h2: "Votre toit ne peut pas attendre la prochaine tempête",
  cta_subtitle: 'Intervention rapide, équipe assurée, tarif clair avant départ.',
  cta_button: 'Demander une soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demander une soumission déneigement',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle rapidement.',
  form_success: 'Demande envoyée !',
  form_success_sub: "On vous rappelle dans l'heure pour évaluer votre situation. Merci de nous faire confiance.",
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_adresse_label: 'Adresse',
  form_adresse_placeholder: 'Votre adresse à Lévis, QC',
  form_service_label: "Service d'urgence souhaité",
  form_service_select: "Sélectionnez un service",
  form_service_deneigement: 'Déneigement toit plat',
  form_service_pente: 'Déneigement toit en pente',
  form_service_deglaçage: 'Déglaçage vapeur',
  form_service_glaçons: 'Retrait glaçons',
  form_service_contrat: 'Contrat saisonnier',
  form_message_label: 'Description de la situation',
  form_message_placeholder: "Décrivez l'accumulation, type de toit, accès...",
  form_char_count: '/500',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default deneigementTranslations;